module.exports = __webpack_public_path__ + "static/img/Globus.eb2240f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/Globus.png
// module id = wBFI
// module chunks = 0